export enum UserType {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  USER = 3,
  MODERATOR = 5,
  NO_ACCESS = 7,
  BANNED = 8,
  ACCESS_REQUESTED = 13,
  ACCESS_DECLINED = 14,
  INVITED_OWNER = 15,
  SUPPORT = 16,
  ENGINEER = 17
}
